export const MALE = "m", FEMALE = "f"
export const metric = "metric", imperial = "imperial"

export const MONTHLY = "monthly", ANNUAL = "annually"
export const PERFORMANCE_MODE = "PERFORMANCE", DAILY_MODE = "DAILY"